import { FC, useEffect, useState } from "react";
import { lCHarSVG } from "../../../assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import { selectedService } from "../../../types/service";
import ServiceWithTeamMemberSelect from "./ServiceWithTeamMemberSelect";
import { setPackages, setServices } from "../../../services/store/slices/cart";
import { FiCheckSquare } from "react-icons/fi";
import { BsPerson } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import { clientGetAvailableTeamMembers } from "../../../network/clientSide";
import { selectedPackages } from "../../../types/package";
import PackageWithTeamMemberSelect from "./PackageWithTeamMemberSelect";
import { availableTeamMember } from "../../../types/calendar";
import { useIntl } from "react-intl";

interface ServicesTemMembersProps {}

const ServicesTemMembers: FC<ServicesTemMembersProps> = ({}) => {
  const intl = useIntl();
  const { services, packages, location, date, token } = useSelector(
    (state: {
      cart: {
        services: {
          services: selectedService[];
          packages: selectedPackages[];
          date: Date | null;
          start_time: string | null;
        };
        location: { id: number | null };
        client: {
          // phoneNumber:  string | null,
          // phoneCountryCode:  string | null,
          token: string | null;
        };
      };
    }) => {
      return {
        services: state.cart.services.services,
        packages: state.cart.services.packages,
        location: state.cart.location,
        date: state.cart.services.date,
        token: state.cart.client.token,
      };
    }
  );
  const { data: teamMembers, isLoading } = useQuery(
    [
      "availableTeamMembers",
      date,
      ...services?.map((item: { id: Number }) => item?.id),
    ],
    () =>
      clientGetAvailableTeamMembers(location?.id, token, {
        date,
        pricing_option_ids: services?.map((item: { id: Number }) => item?.id),
        package_ids: packages?.map((item: { id: Number }) => item?.id),
      }),
    {
      enabled: !!token && !!date,
      select: (res) => res?.data?.data,
    }
  );
  const dispatch = useDispatch();
  const [manualSelect, setManualSelect] = useState(true);
  const handleRemoveService = (id: number) => {
    const newServices = services?.filter((service) => service.id !== id);
    dispatch(setServices(newServices));
  };
  const handleRemovePackage = (id: number) => {
    const newPackages = packages?.filter((service) => service.id !== id);
    dispatch(setPackages(newPackages));
  };
  const handleSelectTeamMember = (
    id: number,
    teamMember: {
      id: number;
      name: string;
      media: string;
    },
    type: "service" | "package"
  ) => {
    console.log(id, teamMember, type);
    if (type === "service") {
      const newService = services?.find((service) => service.id === id);
      if (!newService) {
        return;
      }

      const newServices = services?.map((service) => {
        if (service.id === id) {
          return {
            ...newService,
            teamMember: {
              id: teamMember?.id,
              name: teamMember?.name,
              media: teamMember?.media,
            },
          };
        }
        return service;
      });
      dispatch(setServices(newServices));
      return;
    }
    if (type === "package") {
      const newPackage = packages?.find((pkg) => pkg.id === id);
      if (!newPackage) {
        return;
      }

      const newPackages = packages?.map((pkg) => {
        if (pkg.id === id) {
          return {
            ...newPackage,
            teamMember: {
              id: teamMember?.id,
              name: teamMember?.name,
              media: teamMember?.media,
            },
          };
        }
        return pkg;
      });
      dispatch(setPackages(newPackages));
      return;
    }
  };

  useEffect(() => {
    if (!manualSelect) {
      const newServices = services?.map((service) => {
        const teamMember = teamMembers?.find((member: availableTeamMember) =>
          member?.service_id?.includes(service?.service_id)
        );

        if (teamMember) {
          return {
            ...service,
            teamMember,
          };
        } else {
          return service;
        }
      });
      const newPackages = packages?.map((pkg) => {
        const teamMember = teamMembers?.find((member: availableTeamMember) =>
          member?.package_id?.includes(pkg?.id)
        );
        if (teamMember) {
          return {
            ...pkg,
            teamMember,
          };
        } else {
          return pkg;
        }
      });
      dispatch(setServices(newServices));
      dispatch(setPackages(newPackages));
    }
  }, [manualSelect]);

  return (
    <div className="shadow p-6 space-y-4 rounded-lg  ">
      <div className="space-y-4">
        <h4 className="text-salon-primary text-xl ">
          {intl.formatMessage({ id: "servicesAndMembers" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "selectTeamMemberWarningTextService" })}
        </p>
      </div>
      {packages?.length + services?.length > 1 ? (
        <div className="space-y-3">
          <p className="text-salon-primary">
            {intl.formatMessage({ id: "teamMembers" })}
          </p>
          <div className="flex justify-between gap-2 ">
            <div
              onClick={() => {
                setManualSelect(false);
              }}
              className={
                !manualSelect
                  ? "w-full ps-4 cursor-pointer flex items-center gap-2 font-semibold text-salon-primary bg-white p-2 rounded-lg border-solid border-[#479821] border-[1px]"
                  : "w-full ps-4 cursor-pointer flex items-center gap-2 font-semibold bg-[#EEF0FF] p-2 rounded-lg  "
              }
            >
              {!manualSelect ? (
                <FiCheckSquare size={18} color="#479821" />
              ) : null}
              <span className="bg-salon-primary-light w-11 h-11 rounded-full flex justify-center items-center">
                {lCHarSVG}
              </span>
              <span> {intl.formatMessage({ id: "lookFindrSuggestion" })}</span>
            </div>
            <div
              onClick={() => setManualSelect(true)}
              className={
                manualSelect
                  ? "w-full ps-4 cursor-pointer flex items-center gap-2 font-semibold text-salon-primary bg-white p-2 rounded-lg border-solid border-[#479821] border-[1px]"
                  : "w-full ps-4 cursor-pointer flex items-center gap-2 font-semibold bg-[#EEF0FF] p-2 rounded-lg  "
              }
            >
              {manualSelect ? (
                <FiCheckSquare size={18} color="#479821" />
              ) : null}
              <span
                className={
                  manualSelect
                    ? " bg-[#EEF0FF] w-11 h-11 rounded-full flex justify-center items-center"
                    : " bg-white w-11 h-11 rounded-full flex justify-center items-center"
                }
              >
                {manualSelect ? (
                  <BsPerson size={20} color="#00086D" />
                ) : (
                  <BsPerson size={20} color="gray" />
                )}
              </span>
              <span> {intl.formatMessage({ id: "manualSelect" })}</span>
            </div>
          </div>
        </div>
      ) : null}
      <div className="space-y-3">
        <p className="text-salon-primary">
          {intl.formatMessage({ id: "selectedServices" })}
        </p>

        <div className="max-h-[60vh] overflow-auto">
          {services?.map((service, i) => (
            <ServiceWithTeamMemberSelect
              teamMembers={teamMembers}
              manualSelect={manualSelect}
              service={service}
              handleRemoveService={handleRemoveService}
              handleSelectTeamMember={handleSelectTeamMember}
              isLoading={isLoading}
              key={i}
            />
          ))}
        </div>
      </div>
      <div className="space-y-3">
        <p className="text-salon-primary">
          {intl.formatMessage({ id: "selectedPackages" })}
        </p>

        <div className="max-h-[60vh] overflow-auto">
          {packages?.map((pkg, i) => (
            <PackageWithTeamMemberSelect
              teamMembers={teamMembers}
              manualSelect={manualSelect}
              packageItem={pkg}
              handleRemovePackage={handleRemovePackage}
              handleSelectTeamMember={handleSelectTeamMember}
              isLoading={isLoading}
              key={i}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesTemMembers;
